import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import Home from "@/pages/Home";
import Courses from "@/pages/Courses";
import Privacy from "@/pages/Privacy";

function ScrollManager() {
  const location = useLocation();
  const lenis = useLenis();

  useEffect(() => {
    if (typeof window !== "undefined") window.__lenis = lenis;
  }, [lenis]);

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const attempt = () => {
        const el = document.getElementById(id);
        if (el) {
          if (lenis) lenis.scrollTo(el, { offset: -80 });
          else el.scrollIntoView({ behavior: "smooth" });
          return true;
        }
        return false;
      };
      if (!attempt()) setTimeout(attempt, 250);
    } else {
      if (lenis) lenis.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash, lenis]);

  return null;
}

function App() {
  return (
    <div className="App">
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <BrowserRouter>
          <ScrollManager />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </BrowserRouter>
      </ReactLenis>
    </div>
  );
}

export default App;
